module.exports = __webpack_public_path__ + "media/mypage/images/special/011-1cd7bcc7c54e8f69a69bdc28995bc88b.jpg";